import React from "react";
import { Link } from "react-router-dom";
import { Breadcrumb } from "antd";
import { TbSmartHome } from "react-icons/tb";
import { useTranslation } from "react-i18next";

const BreadCrump = ({ link, label, link2Name }) => {
  const { t } = useTranslation("dashboard");
  // The section label comes from localStorage, set when a sidebar entry is clicked; after a direct
  // page load or refresh it is missing and used to show up as "null".
  const hasLabel = Boolean(label) && label !== "null" && label !== "undefined";
  return !hasLabel ||
    link2Name === "Directory" ||
    link2Name === "Ai" ||
    link2Name === "Meetings" ||
    link2Name === "Mail" ||
    link2Name === "Chats" ||
    link2Name === "Invoices" ||
    link2Name === "Profile" ? (
    <Breadcrumb
      items={[
        {
          title: (
            <Link to="/user">
              <TbSmartHome />
            </Link>
          )
        },
        {
          title: t(link2Name)
        }
      ]}
    />
  ) : (
    <Breadcrumb
      items={[
        {
          title: (
            <Link to="/user">
              <TbSmartHome />
            </Link>
          )
        },
        {
          title: (
            <Link to={link} onClick={e => e.preventDefault()}>
              {t(label)}
            </Link>
          )
        },
        {
          title: t(link2Name)
        }
      ]}
    />
  );
};

export default BreadCrump;
